<template>
  <div>
    <modal-cadu close :width="600" style="overflow: hidden;" v-model="valueData">
      <div slot="all" class="px-10 pt-10 pb-4">
        <div slot="header" class="pb-6">
            <div class="font-primaria title font-weight-bold pb-4" style="color: #00995D">
                ADICIONAR INICIATIVA INSTITUCIONAL
            </div>
        </div>
        <div slot="body">
          <ValidationObserver ref="observer">
            <div class="fontColor--text">
              <v-row align="center">
                <v-col cols="12" md="5" class="py-1">
                  <div>Iniciativa Institucional:</div>
                </v-col>
                <v-col cols="12" md="5" class="py-1">
                  <validation-provider
                    name="area"
                    mode="eager"
                    rules="required"
                    v-slot="{ errors }"
                    ref="nome"
                  >
                    <input-cadu
                      :max="150"
                      :errorMessage="errors[0]"
                      :onlyUpperCase="false"
                      v-model="iniciativaSelecionada.nome"
                    />
                  </validation-provider>
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="12" md="5" class="py-1">
                  <div>Tooltip:</div>
                </v-col>
                <v-col cols="12" md="5" class="py-1">
                  <validation-provider
                    name="area"
                    mode="eager"
                    rules="required|max:150"
                    v-slot="{ errors }"
                    ref="descricao"
                  >
                    <input-cadu :errorMessage="errors[0]" v-model="iniciativaSelecionada.descricao" max="150" :onlyUpperCase="false"/>
                  </validation-provider>
                </v-col>
              </v-row>
            </div>
          </ValidationObserver>
        </div>
        <div slot="footer">
          <v-row justify="start">
            <v-col>
              <button-cadu @click="$emit('input', false)">VOLTAR</button-cadu>
            </v-col>
            <v-row justify="end">
              <v-col cols="auto">
                <button-cadu @click="salvarIniciativa">SALVAR</button-cadu>
              </v-col>
            </v-row>
          </v-row>
        </div>
      </div>
    </modal-cadu>
    <overlay-loading v-model="loadingOverlay"/>
    <error-modal :value="showError" @input="fecharModalErro" :errObj="errObj" />
    <SucessoModal
        :genericMessage="'Iniciativa institucional adicionada com sucesso'"
        :showSucess="showSucess"
        @close="fecharModalSucesso"
    />
  </div>
</template>

<script>
import ModalMixin from '@/Mixins/ModalMixin'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import ParametrosGerais from '@/services/ParametrosGerais/ParametrosGerais'

export default {
  components: {
    ValidationObserver,
    ValidationProvider
  },
  mixins: [ModalMixin],
  data () {
    return {
      iniciativaSelecionada: {
        nome: '',
        id: '',
        descricao: ''
      },
      parametrosGerais: '',
      showSucess: false,
      loadingOverlay: false,
      errObj: {},
      showError: false,
      error: false,
      genericMessage: ''
    }
  },
  async created () {
    this.parametrosGerais = new ParametrosGerais(localStorage.getItem('tokenBearer'), this.$appConfig.config.API)
  },
  watch: {
    valueData () {
      if (!this.valueData) {
        this.limparCampos()
        this.$emit('input', false)
      }
    }
  },
  methods: {
    fecharModalSucesso () {
      this.showSucess = false

      this.$emit('att', this.iniciativaSelecionada.nome)
      this.limparCampos()
      this.$emit('input', false)
    },
    async fecharModalErro () {
      this.showError = false
      await this.$nextTick()
      document.documentElement.style.overflow = 'hidden'
    },
    limparCampos () {
      this.iniciativaSelecionada.nome = ''
      this.iniciativaSelecionada.descricao = ''
    },
    async salvarIniciativa () {
      const valid = await this.$refs.observer.validate()
      if (!valid) return
      await this.loadingFunc(this.promiseGeneric(this.parametrosGerais, 'putIniciativaInstitucional', this.formData, this.iniciativaSelecionada.nome, this.iniciativaSelecionada.descricao, this.iniciativaSelecionada.id))
      this.showSucess = true
    },
    async promiseGeneric (className, nomeFunc, ...valoresFunc) {
      try {
        return await className[nomeFunc](...valoresFunc)
      } catch (err) {
        this.setError(err)
      }
    },
    async loadingFunc (...func) {
      this.loadingOverlay = true
      await Promise.all(func)
        .finally(() => {
          this.loadingOverlay = false
        })
    },
    setError (err) {
      if (err.response) {
        this.loadingOverlay = false
        this.showError = true
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
      }
      throw err
    }
  }
}
</script>

<style lang="sass" scoped>
.drag-doc-area
  border-radius: 22px
  position: relative

.drag-text-icon
  width: 100%
  height: 80px

.icon
  width: 100%
  height: 80px
  border-radius: 22px
  background-color: #FFF
  color: #00995d

.text
  cursor: pointer
  color: #00995d

.input-file
  opacity: 0
  position: absolute
  top: 0
  height: 100%
  width: 100%

  \:hover
    cursor: pointer
</style>
